<template>
  <div>
      <b-modal
        v-model="showReopenConfirmModal"
        ok-title="Submit"
        title="Confirm Reopen"
        @ok="reopen($event)"
        @cancel="eventCancel($event)"
        :centered="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :ok-only="true"
        :ok-disabled="enableSubmit"
        :size="'xl'"
      >
        <w-text-area onpaste="return false"
          :rows="3"
          style="text-align: left;padding-left:1%"
          @inputChanges="overallRemarksPopup($event)"
          :title="'Remarks'"
          maxCharacter="500"
          validation="required"
        />
        
      <!-- attachment -->
      <div v-for="(i,index) in reopenAttachments" :key="i" style="padding:0px 40px;">
           <input class="form-control" type="text" style="max-width:200px;display:inline-block;margin-right:20px;" 
           v-model="i.nameOfTheAttachment" :placeholder="'Name of the attachment..'"/>  
           
              <div style="display:inline-block;">
                <FileUploader style="display: inline-block;"
                  :heading="'Attach document'"
                  @fileInputChange="UploadDocument($event, index, true)"
                />

                <ul style="list-style-type:disc;display: inline-block;" v-if="i.attachmentFileId">
                  <li style="max-width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    <a
                      @click="showAttachFile(i.attachmentFileId)"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(i.attachmentFileId)}}</a>
                  </li>
                </ul>
                <span @click="removeReopenAttachment(index)" style="padding: 25px;cursor:pointer;" 
                title="Remove Attachment">
                  <img style="height:25px" src="@/assets/delete_Icon.svg"/></span>
              </div>

          </div>
          <div style="padding:0px 40px;">
          <button @click="addReopenAttachment()" class="btn btn-primary" 
          style="padding: 0px 10px;margin-top: 5px;"> + Add more attachments</button>
          </div>
      </b-modal>
    <div
      v-if="FeedbackStatus != 'workflow' && viewAs != 'approver'"
      @click="navigateFeedbackPage()" style="display: block;margin-top: 0px !important;
      text-align: right;margin-right: 25px;margin-bottom: -20px;position: absolute;
    z-index: 1;right: 0px;padding: 5px 20px;cursor:pointer;"
    ><span style="font-size: 20px;color: #0843a8;">Back</span>
      <img class="back-arrow-icon" src="@/assets/images/right-arrow.svg" />
    </div>
    <div class="card m-4">
      <div style="text-align: left;margin-bottom:0px;padding: 10px 0px;">
      <span class="text-left text-heading ml-2 mt-2">Request Details
        </span>
          </div>
           <div style="font-weight: bold;text-align: left;padding-left: 30px;padding-bottom:10px;"
         v-if="viewAs=='New' || viewAs=='draft'">
         Company Selected: {{currentCompanySelected}}</div>
      <div class="row ml-3" v-if="FeedbackStatus != 'workflow'">
        <div class="col-12 col-md-4 text-subheading" v-if="viewAs == 'New'">
          <p class="text-left">Job Code: {{jobCode}}</p>
        </div>
        <div class="col-12 col-md-4 text-subheading" v-if="viewAs == 'New'">
          <p class="text-left">Job Name: {{jobDesc}}</p>
        </div>
        <div class="col-12 col-md-4 text-subheading" v-if="viewAs == 'New'">
          <p class="text-left">PO/WO Number: {{poNumber}}</p>
        </div>
        
        <div class="col-12 col-md-4 text-subheading" v-if="viewAs == 'draft' || viewAs == 'history'">
          <p class="text-left">Job Code: {{claimObj.jobCode}}</p>
        </div>
        <div class="col-12 col-md-4 text-subheading" v-if="viewAs == 'draft' || viewAs == 'history'">
          <p class="text-left">Request Status: {{getStatus(claimObj.statusId)}}</p>
        </div>
        <div class="col-12 col-md-4 text-subheading" v-if="viewAs == 'draft' || viewAs == 'history'">
          <p class="text-left">Document Number: {{claimObj.requestNumber}}</p>
        </div>
        <div class="col-12 col-md-4 text-subheading" v-if="viewAs == 'draft' || viewAs == 'history'">
          <p class="text-left">PO/WO Number: {{claimObj ? claimObj.orderNumber:""}}</p>
        </div> 
        <div class="col-12 col-md-4 text-subheading" v-if="viewAs == 'draft' || viewAs == 'history'">
          <p class="text-left">Updated Date: 
            {{dataFormat(claimObj.updatedOn) == 'Invalid date' ? claimObj.updatedOn : dataFormat(claimObj.updatedOn)}}</p>
        </div>
        
      </div>
      <hr />
      <h4 class="text-left text-heading ml-2 mt-2" v-if="viewAs != 'approver'">
        Details of Grievance Request
        <span class="ml-1 subTitleClass">(Mandatory)</span>
      </h4>
      <div class="row" v-if="viewAs == 'approver'">
        <div class="col-10">
        <div class="table table-responsive">        
<table class="table-bordered claim-details-table"> 
  <tbody> 
    <tr>
    <tr>
    <td>Job Code:</td> <td>{{claimDetails.jobCode}}</td> 
    </tr>
    <tr>
    <td>Order Number:</td> <td>{{claimDetails.orderNumber}}</td> 
    </tr>
    <tr>
    <td>Updated Date:</td> <td>{{dataFormat(claimDetails.updatedOn)}}</td> 
    </tr>
    <td>Reason for Grievance:</td> <td> <span v-if="!editClaim">{{
      reasonForVariation.filter(x=>x.value == claimDetails.reasonTypeCode)[0] ? 
      reasonForVariation.filter(x=>x.value == claimDetails.reasonTypeCode)[0].text : ''}} 
      </span>
      
      <span v-if="editClaim">
        
            <w-dropDown
              class="width-control-small"
              :options="reasonForVariation"
              validation="required"
              @dropdownChange="changeReasonForVariation($event)"
              :selected="changedReasonForVariation"
            />

      </span>
      <span style="float: right;padding-top: 10px;" >
        <span class="editreasonlink" style="margin-right:10px;
        border: 1px solid green;
    padding: 2px 10px;
    margin-top: 10px;
    border-radius: 10px;color:green;"  :class="changedReasonForVariation != '' ? '': 'disabled-opaque'"
        v-if="editClaim" @click="saveChangeReasonForVariation()">Save</span>
        <span class="editreasonlink" style="color:red;margin-right:10px;
        border: 1px solid red;
    padding: 2px 10px;
    margin-top: 10px;
    border-radius: 10px;"
         v-if="editClaim" @click="editClaim = false">Cancel</span>
         <button class="btn-border" v-if="!editClaim">
                  <img
                    class="mr-2 mt-1 cursor-pointer"
                    src="@/assets/edit-small.png"
                    alt="icon"
                    height="17px"
                    width="17px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Edit"
                    animation="true"
                    @click="editClaimReasonType()"
                  />
                </button>

                
        <span style="color:green" v-if="changeReasonSavedSuccess==true">Saved Successfully!</span>
      </span>
      </td>     
    </tr> 
    <tr>
    <td>Grievance Description:</td> <td>{{claimDetails.variationDesc}}</td> 
    </tr>
    <tr>
    <td>Attachments:</td> <td><div v-for="(i,index) in JSON.parse(claimDetails.attachmentDocIds)" :key="i">
           <span>{{i.nameOfTheAttachment}}:</span> 
           
              <div style="display:inline-block;">
                <FileUploader v-if="viewAs == 'New'"
                  :heading="'Attach Relevant documents/proofs'"
                  @fileInputChange="UploadDocument($event, index)"
                />

                <ul style="list-style-type:disc;" v-if="i.attachmentFileId">
                  <li>
                    <a
                      @click="showAttachFile(i.attachmentFileId)"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(i.attachmentFileId)}}</a>
                  </li>
                </ul>
              </div>

          </div></td> 
    </tr>
    <tr>
    <td>Reference Document Number:</td> <td>{{claimDetails.referenceDocument}}</td> 
    </tr>
    
    <tr>
    <td>Site Person or Employee Contacted for this issue:</td> <td>{{claimDetails.employeeDetails}}</td> 
    </tr>
    </tbody>
</table>
  </div>
  <div style="text-align: left;padding: 15px;" v-if="false">
    <div style="margin-bottom:10px;"> 
    <span>Response by L&T: *</span>
    <textarea style="background:#fff;width:100%;" class="form-control"
    v-model="currentResponseByLNT" 
    @input="processLntResponse()"/>
    </div>
    <div>
   <span> Document Number:</span>
   <input style="background:#fff;width:100%;" class="form-control" v-model="currentDocByLNT" 
    @input="processLntResponse()"/>
    </div>
  </div>
        </div>
      </div>
      <div v-if="viewAs != 'approver'"
      :class="disableEdit()"
       class="row m-0 px-0 py-3"  style="background: #f5f5f5;border-bottom: 5px solid #fff;">
        <div class="col-3 f-bold">
          <b-form-group
            class="source-sans-pro field-headings text-left f-bold" 
            label="Reason for Grievance"
          >
            <w-dropDown
              class="width-control-small"
              :options="reasonForVariation"
              validation="required"
              @dropdownChange="getReasonForVariationDetails($event)"
              :selected="selectedReasonForVariation"
            />
          </b-form-group>
        </div>
      </div>
      <div v-if="viewAs != 'approver'" style="background: #f5f5f5;border-bottom: 5px solid #fff;width:100% !important;">
      <div class="multi-select" 
      :class="disableEdit()">
        <p class="source-sans-pro px-3 text-left inner-sub-headings m-0 f-bold">Description of Grievance*</p>
        <w-text-area
          :rows="5"
          class="pl-3 pt-2"
          @inputChanges="getSegRemarks($event)"
          :value="variationDesc"
          maxCharacter="4000"
          validation="required"
        />
      </div>
      </div>
      <div v-if="viewAs != 'approver'" class="row m-0 px-0 py-3"      
     
       style="background: #f5f5f5;border-bottom: 5px solid #fff;">
        <div class="col-12" style="text-align: left;">
          <div style="font-weight:bold;">Attachments</div>
          <!--b-form-group class="source-sans-pro field-headings text-left" label="Attachments">
            <w-dropDown
              class="width-control-small"
              :options="attachmentType"
              validation="required"
              @dropdownChange="getAttachmentTypeDetails($event)"
              :selected="selectedAttachmentType"
            />
          </b-form-group-->
          <div v-for="(i,index) in attachments" :key="i">
           <input class="form-control" type="text" style="max-width:200px;display:inline-block;margin-right:20px;" 
           v-model="i.nameOfTheAttachment" :placeholder="'Name of the attachment..'"
           @keypress="isAlphaNumber($event)"  :class="disableEdit()"/>  
           
              <div style="display:inline-block;">
                <FileUploader v-if="viewAs == 'New' || viewAs=='draft' || (viewAs=='history' && claimObj.statusId==2 )" style="display: inline-block;"
                  :heading="'Attach Relevant documents/proofs'"
                  @fileInputChange="UploadDocument($event, index)"
                />

                <ul style="list-style-type:disc;display: inline-block;" v-if="i.attachmentFileId">
                  <li style="max-width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    <a
                      @click="showAttachFile(i.attachmentFileId)"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(i.attachmentFileId)}}</a>
                  </li>
                </ul>
                <span @click="removeAttachment(index)" style="padding: 25px;cursor:pointer;" 
                title="Remove Attachment" v-if="viewAs == 'New' || viewAs=='draft' || (viewAs=='history' && claimObj.statusId==2 )">
                  <img style="height:25px" src="@/assets/delete_Icon.svg"/></span>
              </div>

          </div>
          <button @click="addAttachment()" class="btn btn-primary" 
          style="padding: 0px 10px;margin-top: 5px;" v-if="viewAs=='New' || viewAs=='draft'
          || (viewAs=='history' && claimObj.statusId == 2)"> + Add more attachments</button>

        </div>
        <div class="col-3" v-if="selectedAttachmentType==57" 
      :class="disableEdit()">
          <w-text-input            
            :className="'f-bold'"
            :labelName="$t('Attachment Type')"
            @textInputChange="getDesignation($event)"
            validation="required"
            :defaultValue="form.designation"
            :allowOnlyCharacters="true"
            :maxCharacter="'100'"
          />
        </div>
      </div>
      <div v-if="viewAs != 'approver'" class="row m-0 px-0 py-3" style="background: #f5f5f5;border-bottom: 5px solid #fff;">
        <div class="col-3 source-sans-pro text-left inner-sub-headings f-bold" 
      :class="disableEdit()">
          <w-text-input
            :className="'f-bold'"
            :labelName="$t('Reference Document number')"
            @textInputChange="getRefNumber($event)"
            validation="required | regex_alpha_numeric_space"
            :defaultValue="form.referenceNumber"
            :maxCharacter="'100'"
          />
        </div>
      </div>

      
      <div v-if="viewAs != 'approver'" 
      class="row m-0 px-0 py-3" style="background: #f5f5f5;border-bottom: 5px solid #fff;">
        <div class="col-6 source-sans-pro text-left inner-sub-headings f-bold" 
      :class="disableEdit()">
          <w-text-input            
            :className="'f-bold'"
            :labelName="$t('L&T Employee or Site Person Contacted for this issue:')"
            @textInputChange="getEmpDetailsNumber($event)"
            validation="required | regex_alpha_numeric_space"
            :defaultValue="form.employeeDetails"
            :maxCharacter="'100'"
            :placeholder="'Name/ Email/ Mobile'"
          />
        </div>
      </div>
    </div>
    <div id="trace" class="table table-responsive" v-if="viewAs == 'history' || viewAs == 'approver'">
      <h5>History of the request:</h5>
      <table class="table-striped wf-history-table" style="width: 100%;">
  <thead><tr>
    <th>Sender</th>
    <th>Action</th>
    <th>Remarks</th>
    <th>Attachments</th>
    <th>Date</th>
    <!--th>Version Number</th>
    <th>Company Code</th>
    <th>Doc WF Id</th-->
    </tr></thead>
  <tbody> 
    <tr v-for="(i,index) in historyList" :key="index">
    <td>{{i.sender}}</td>
    <td>{{i.action}}</td>
    <td>{{i.remarks}}</td>
    
    <td>
    <div v-for="(i,index) in JSON.parse(i.attachmentJson)" :key="i">
           <span>{{i.nameOfTheAttachment}}:</span> 
           
              <div style="display:inline-block;">
                <FileUploader v-if="viewAs == 'New'"
                  :heading="'Attach Relevant documents/proofs'"
                  @fileInputChange="UploadDocument($event, index)"
                />

                <ul style="list-style-type:disc;" v-if="i.attachmentFileId">
                  <li>
                    <a
                      @click="showAttachFile(i.attachmentFileId)"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(i.attachmentFileId)}}</a>
                  </li>
                </ul>
              </div>

          </div>
    </td>
    <td>{{formatDateTime(i.date, 'T')}}</td>
    <!--td>{{i.versionNumber}}</td>
    <td>{{i.companyCode}}</td>
    <td>{{i.documentWorkflowId}}</td-->
    </tr>
    </tbody>
</table>
    </div>
        <div v-if="viewAs == 'history' && (claimObj.statusId == 8)" 
      :class="viewAs=='history'  ? '' : 'disabled'">
          <button class="btn btn-success" @click="accept()">Accept & Close</button>
          <button class="btn btn-primary" style="margin-left:10px;" @click="reopenConfirm()">Reopen</button>
        </div>
        <div v-if="viewAs == 'history' && (claimObj.statusId == 8)" style="margin-top:10px;">
         Note: The request will be auto-closed in 3 days if no action taken.</div>
    <div v-bind:style="[viewAs == 'New' || viewAs == 'draft' ? {marginBottom:'200px'} : {}]">
      <div style="padding: 0px 25px;font-weight: bold;text-align: center;
      width: 70%;margin: auto;"
      v-if="viewAs == 'New' || viewAs == 'draft' || (viewAs == 'history' && claimObj.statusId == 2)" > 
        <input type="checkbox" style="width: 18px;height: 18px;margin-right: 10px;
        vertical-align: text-bottom;font-size:16px;outline: 2px solid #c3c3c3;"
        v-model="acknowledge"/><span @click="acknowledge=!acknowledge" 
        style="font-size:16px;user-select: none;cursor:pointer;">
          I hereby declare that I had put efforts to resolve this issue 
        by discussing with the person/s mentioned above. We would like to escalate the matter 
        to the next level for resolution.</span></div>
      <div class="mt-3 mb-4" v-if="viewAs == 'New' || viewAs == 'draft'">
        <b-button class="draft-button mr-5" @click="submitFeedbackAsDraft()">
          <img alt src="@/assets/book-mark.svg" />
          Save as Draft
        </b-button>
        <b-button :class="acknowledge ? '' : 'disabled'"
          @click="submitClaim()"
          class="submit-button mr-3"
        >Submit Grievance Request</b-button>
      </div>
      <div class="mt-3 mb-4" v-if="viewAs == 'history' && claimObj.statusId == 2" >       
        <b-button :class="acknowledge ? '' : 'disabled'"
          @click="submitClaimReSubmit()"
          class="submit-button mr-3"
        >Re Submit Grievance Request</b-button>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
    <!-- <w-radio :radioLabel="'test'" :formRadio="radioInput" /> -->
    <w-modal
      :trigger="triggerModal"
      :text="lastResponse"
      :extraMessage="messageResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="changeModalSuccess()"
    />

  </div>
</template>

<script>
import Radio from "../../widgets/Feedbackradio";
import Textarea from "../../widgets/TextArea";
import CustomTextInput from "../../widgets/CustomTextInput";
import textInput from "../../widgets/TextInput";
import widgetModal from "../../widgets/newModalWidget";
import loadingSpinner from "../../widgets/LoadingSpinner";
import DropDown from "../../widgets/DropDown";
import moment from "moment";
import FileUploader from "../../widgets/FileUploader.vue";
import { PartnerService } from "../../services/partnerService";
const partnerService = new PartnerService();
import { SummaryServices } from "../../services/summaryService";
const summaryService = new SummaryServices();
import { OnBoardingServices } from "../../services/onBoardingService";
const onBoardingServices = new OnBoardingServices();

export default {
  props: [
    "poNumber",
    "vendorCode",
    "jobCode",
    "companyCode",
    "jobType",
    "FeedbackStatus",
    "documentNumber",
    "jobDesc",
    "selectedCategory",
    "claimObj",
    "viewAs",
    "claimDetails",
    "answernumber"
  ],

  components: {
    "w-text-area": Textarea,
    "w-radio": Radio,
    "w-customtext-input": CustomTextInput,
    "w-text-input": textInput,
    "w-modal": widgetModal,
    "w-loadingSpinner": loadingSpinner,
    "w-dropDown": DropDown,
    FileUploader
  },
  mounted() {
    this.getReasonForVariation();
    this.getAttachmentType();
    if(this.viewAs == "history" ) {
      this.getWorkFlowHistoryPCR(this.claimObj.requestNumber)
    }
    if(this.viewAs == "approver" ) {
      this.getWorkFlowHistoryPCR(this.answernumber)
    }
    if (this.viewAs == "history" || this.viewAs == "draft") {
      this.jobCode = this.claimObj.jobCode
      this.jobDesc = this.claimObj.jobCode
      this.form.referenceNumber = this.claimObj.referenceDocument
      this.form.employeeDetails = this.claimObj.employeeDetails
      this.selectedCategory = this.claimObj.categoryCode
      this.variationDesc = this.claimObj.variationDesc
      this.poNumber = this.claimObj.orderNumber
      this.attachments = JSON.parse(this.claimObj.attachmentDocIds)
      this.selectedReasonForVariation = this.claimObj.reasonTypeCode
      this.$forceUpdate();
    }
    if (this.viewAs == "draft") {
    }
  },

  data() {
    return {
      acknowledge: false,
      changeReasonSavedSuccess: false,
      changedReasonForVariation: '',
      editClaim: false,
      historyList:[],
      currentResponseByLNT:'',
      currentDocByLNT:'',
      currentCompanySelected: sessionStorage.getItem("currentCompanyName"),
      siteUrl: "",
      saveDraftObj: {},
      loading: false,
      variationDesc: "",
      reasonForVariation: [],
      attachmentType: [], 
      selectedReasonForVariation: "",
      selectedAttachmentType: "",
      module: "financial",
      financialData: "",
      financialValue: [],
      financialStrength: "",
      financialOthers: "",
      financialmerge: "",
      getEvaluationData: [],
      modulesArray: [],
      panel: 0,
      FeedbackStatus: "",
      viewEvaluation: false,
      triggerModal: false,
      lastResponse: "",
      messageResponse: "",
      workflowOrderNumber: "",
      workflowjobType: "",
      alertModal: false,
      successModal: false,
      jobDesc: "",
      poOrderDate: "",
      workflowJobCode: "",
      fetchedDocumentNumber:"",
      form: {
        companyCode: 1,
        designation: null,
        referenceNumber: "",
        employeeDetails:"",
        documentNumber: "",
        email: null,
        jobCode: "",
        mobileNumber: null,
        name: null,
        orderNumber: "",
        orderType: "",
        partnerNumber: "",
        dynamicQuestionControlResponse: {
          modules: []
        }
      },
      attachments:[{"nameOfTheAttachment":"","attachmentFileId":"","attachmentSiteUrl":""}],
      attachmentObj:{"nameOfTheAttachment":"","attachmentFileId":"","attachementSiteUrl":""},
      reopenAttachments:[{"nameOfTheAttachment":"","attachmentFileId":"","attachementSiteUrl":""}],
      reopenAttachmentObj:{"nameOfTheAttachment":"","attachmentFileId":"","attachmentSiteUrl":""},
      reopenRemarks: "default reopen remark",      
      enableSubmit: true,
      showReopenConfirmModal: false,
      claimForm: {
        documentNumber: "",
        categoryCode: 1,
        reasonTypeCode: 0,
        attachmentTypeCode: 0,
        attachmentType: "",
        variationDesc: "",
        referenceDocument: "",
        employeeDetails: "",
        lntRepName: "",
        lntRepMail: "",
        jobCode: "",
        orderNumber: ""
      }
    };
  },
  methods: {  
    
    isAlphaNumber(event) {
      if (!/^[a-zA-Z0-9 ]*$/.test(event.key))   
        return event.preventDefault();  
    },
    changeReasonForVariation(e){
      this.changedReasonForVariation = e
    },
    saveChangeReasonForVariation(){
      //save grievance type
      var self = this;      
      this.loading = true;
      partnerService.claimReasonChange(this.answernumber, this.changedReasonForVariation)
        .then(resp => {
          this.loading = false;
          if (resp.status == "SUCCESS") {            
              this.editClaim = false;
              self.changeReasonSavedSuccess = true;              
                window.alert('Grievance reason type changed successfully!')
                self.$router.go(0)
          } else {
            window.alert('Problem saving grievance reason. try again later.')
          }/*
          if (resp) {       
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = "Reopened Successfully";
          this.alertsuccess = true;
          }*/
        })
        .catch(error => {
          this.loading = false;
            window.alert('Problem saving grievance reason. try again later.')
        });
      
    },
    editClaimReasonType() {
      this.editClaim = true;
      this.changedReasonForVariation = '';
    },
    disableEdit(){
      return (this.viewAs=='New' || 
      this.viewAs=='draft' || 
      (this.viewAs=='history' && this.claimObj.statusId == 2))  ? '' : 'disabled'
    },
    getWorkFlowHistoryPCR(doc){
      var self = this 
      summaryService.getWorkFlowHistoryBetter(doc)
        .then(res => {
          console.log(res)
          this.loading = false;
            if (res.status == "SUCCESS") {
          this.historyList = res.response;
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.failureModal = false;              
              this.lastResponse = res.failureMessage; 
              this.alertModal = true;
            }})
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage ? err.failureMessage : "Something went wrong. Try again later.";
              this.alertModal = true;
        });
    },
    overallRemarksPopup(event) {
      if (event.length > 3) {
        this.enableSubmit = false;
      } else {
        this.enableSubmit = true;
      }
      this.reopenRemarks = event;
    },
    reopenConfirm(){
        this.reopenRemarks = "";
        this.enableSubmit = true;
        this.showReopenConfirmModal = true;
    },
    accept() {
      if (window.confirm("Do you want to accept and close this grievance resolution. Click OK to confirm?")) {
      var data ={"companyCode": this.companyCode,
      "documentNumber": this.claimObj.requestNumber,
      "jobCode": this.claimObj.jobCode,
      "reasonTypeCode": this.claimObj.reasonTypeCode,
      "remarks": this.reopenRemarks}

      partnerService.claimClose(data)
        .then(resp => {
          if (resp.status == "SUCCESS") {
            this.triggerModal = true;
            this.successModal = true;
            this.alertsuccess = true;
            this.lastResponse = resp.response;
          } else {
            this.triggerModal = true;
            this.alertsuccess = true;
            this.lastResponse = resp.failureMessage;
          }/*
          if (resp) {       
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = "Reopened Successfully";
          this.alertsuccess = true;
          }*/
        })
        .catch(error => {
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = "Something went wrong. Try again after Sometime.";
          this.alertsuccess = true;
        });
      }
    },
    reopen() {      
      var data ={"companyCode": this.companyCode,
      "documentNumber": this.claimObj.requestNumber,
      "jobCode": this.claimObj.jobCode,
      "reasonTypeCode": this.claimObj.reasonTypeCode,
      "remarks": this.reopenRemarks,
      "attachmentJson": JSON.stringify(this.reopenAttachments)}

      partnerService.claimReopen(data)
        .then(resp => {
          if (resp.status == "SUCCESS") {
            this.triggerModal = true;
            this.successModal = true;
            this.alertsuccess = true;
            this.lastResponse = resp.response.Message;
          } else {
            this.triggerModal = true;
            this.alertsuccess = true;
            this.lastResponse = resp.failureMessage;
          }/*
          if (resp) {       
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = "Reopened Successfully";
          this.alertsuccess = true;
          }*/
        })
        .catch(error => {
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = "Something went wrong. Try again after Sometime.";
          this.alertsuccess = true;
        });
    }, 
    processLntResponse(){
      var self = this
      EventBus.$emit('responseByLnt', self.currentResponseByLNT + "~!~" + self.currentDocByLNT); 
    },
    showAttachFile(event) {
      onBoardingServices.downLoadDocument(event).then(res => {});
    },
    removeAttachment(i){
      if(this.attachments.length>1){
      this.attachments.splice(i, 1)
      } else{
        this.attachments =[{"nameOfTheAttachment":"","attachmentFileId":"","attachmentSiteUrl":""}]
      }
    },
    removeReopenAttachment(i){
      if(this.reopenAttachments.length>1){
      this.reopenAttachments.splice(i, 1)
      } else{
        this.reopenAttachments =[{"nameOfTheAttachment":"","attachmentFileId":"","attachmentSiteUrl":""}]
      }
    },
    formatDateTime(dt, splitter){ 
      console.log(dt)
      var dateArray = (dt.split(splitter)[0]).split('-')
      var timeArray = (dt.split(splitter)[1]).split(':')
      var date = dateArray[2]
      var month = dateArray[1]
      var year = dateArray[0] 
      var h = timeArray[0]
      var m = timeArray[1]
      
      var ampm = (h >= 12) ? "PM" : "AM"
      h = ((h > 12) ? h-12 : h)
      h = (h.toString()).length == 1 ? ('0'+h) : h
      return (date + '-' + month + '-' + year) + ' ' + h + ":" + m + " " + ampm;
    },
    getStatus(id){
      if (id==1){ return 'Approved'}
      else if (id==2){ return 'Sendback'} 
      else if (id==3){ return 'Rejected'}
      else if (id==4){ return 'Requested'}
      else if (id==5){ return 'Partially Approved'}
      else if (id==6){ return 'Auto Cancel'}
      else if (id==7){ return 'Created'}
      else if (id==8){ return 'Resolved'}
      else if (id==9){ return 'Closed'}
      else if (id==10){ return 'Forwarded'}
      else if (id==11){ return 'Reopened'}
    },
    getFileName(fileName) {
      if (fileName != null) {
        var fileNameFinal = null;
        fileNameFinal = fileName.split(/_(.+)/)[1];
        return fileNameFinal;
      }
      return fileNameFinal;
    },
    addAttachment(){
      if(this.attachments.length < 10) {
        this.attachments.push({"nameOfTheAttachment":"","attachmentFileId":"","attachmentSiteUrl":""})
      } else {
        window.alert('You have reached the maximum limit of attachments!')
      }
    },
    addReopenAttachment(){
      if(this.reopenAttachments.length < 10) {
        this.reopenAttachments.push({"nameOfTheAttachment":"","attachmentFileId":"","attachmentSiteUrl":""})
      } else {
        window.alert('You have reached the maximum limit of attachments!')
      }
    },
    UploadDocument(event,index,isReopen) {
      let data = new FormData();
      let file = event[0];
      // data.append("name", "my-file");
      data.append("file", file);
      this.loading = true;

      onBoardingServices.uploadAttachments(data)
        .then(resp => {
          if (resp) {
            this.loading = false;
            if(isReopen){
            this.reopenAttachments[index].attachmentFileId = resp.UniqueID;
            this.reopenAttachments[index].attachmentSiteUrl = resp.SiteUrl;
            this.siteUrl = resp.SiteUrl;
            } else {
            this.attachments[index].attachmentFileId = resp.UniqueID;
            this.attachments[index].attachmentSiteUrl = resp.SiteUrl;
            this.siteUrl = resp.SiteUrl;
            }
          } else{            
          this.triggerModal = true;
          this.loading = false;
          this.triggerModal = true;
          this.lastResponse = "Something went wrong. Try After Sometime";
          this.alertsuccess = true;
          }
        })
        .catch(error => {
          this.triggerModal = true;
          this.loading = false;
          this.triggerModal = true;
          this.lastResponse = " Try After Sometime";
          this.alertsuccess = true;
        });
    },
    getPartnerName(event) {
      this.form.name = event;
    },
    getDesignation(event) {
      this.form.designation = event;
    },
    getRefNumber(e){
      this.form.referenceNumber = e;
    },
    getEmpDetailsNumber(e){
      this.form.employeeDetails = e;
    },
    getEmailId(event) {
      this.form.email = event;
    },
    getMobileNumber(event) {
      this.form.mobileNumber = event;
    },
    getRadioOptions(answers) {
      let radioOptions = [];
      answers.forEach(element => {
        if (element.controlType == "R") {
          radioOptions.push(element);
        }
      });
      return radioOptions; 
    },
    getReasonForVariation() {
      onBoardingServices.getVarReason().then(res => {
        res.response.forEach(varReason => {
          this.reasonForVariation.push({
            text: varReason.displayName,
            value: varReason.miscTypeDetailsCode
          });
        });
      });
    },
    getAttachmentType() {
      onBoardingServices.getVarType().then(res => {
        res.response.forEach(varType => {
          this.attachmentType.push({
            text: varType.displayName,
            value: varType.miscTypeDetailsCode
          });
        });
      });
    },
    getReasonForVariationDetails(event) {
      this.selectedReasonForVariation = event;
      console.log(event);
    },
    getSegRemarks(event) {
      this.variationDesc = event;
      console.log(event);
    },    
    getAttachmentTypeDetails(event) {
      this.selectedAttachmentType = event;
      console.log(event);
    },
    dataFormat(date) {
      return moment(date).format("DD MMM YYYY HH:MM");
    },
    checkStatus() {
      if (
        this.FeedbackStatus == "workflow" ||
        this.FeedbackStatus == "History"
      ) {
        return false;
      } else {
        return true;
      }
    },
    fieldValidation(questionType) {
      let regularExp = "";
      switch (questionType) {
        case "M":
          regularExp = "required|regex_mobile_number";
          break;
        case "E":
          regularExp = "required|email";
          break;
        case "A":
          regularExp = "required|regex_alpha_special";
          break;
        case "AC":
          regularExp = "required|regex_alphacaps";
          break;
        case "AS":
          regularExp = "required|alpha_spaces";
          break;
        case "N":
          regularExp = "required|regex_number";
          break;
        case "N33":
          regularExp = "required|regex_numless33";
          break;
        case "AN":
          regularExp = "required|regex_alpha_numeric_space";
          break;
        case "P":
          regularExp = "required|regex_percentage";
          break;
        case "PD":
          regularExp = "required|regex_percentage_decimal";
          break;
        case "ASC":
          regularExp = "required|regex_alpha_special";
          break;
        case "UCY":
          regularExp = "required|regex_year";
          break;
        case "PN":
          regularExp = "required|regex_negnumber";
          break;
        case "ANS":
          regularExp = "required|regex_alpha_numeric_special";
          break;
        default:
          regularExp = "required|regex_alpha_numeric_special";
      }
      return regularExp;
    },
    jobSpec(code, name) {
      if (name == "name") {
        var name = code.split("~");
        return name[1];
      } else {
        var name = code.split("~");
        return name[0];
      }
    },
    getRadioInputValue(selectedObj, questionObj, moduleObj) {
      this.setQuestionAnswer(
        selectedObj.keyDesc,
        selectedObj,
        questionObj,
        moduleObj
      );
      this.modulesArray.forEach(element => {
        if (element.moduleCode == moduleObj.moduleCode) {
          element.question.forEach(qes => {
            if (qes.questionCode == questionObj.questionCode) {
              qes.answer = qes.answer.filter(e => {
                return e.answerCode === selectedObj.answerCode;
              });
            }
          });
        }
      });
    },
    getTextAreaInputValue(keyDesc, selectedObj, questionObj, moduleObj) {
      this.setQuestionAnswer(keyDesc, selectedObj, questionObj, moduleObj);
    },
    getRadioInputofAdditional(selectedObj, questionObj, moduleObj) {
      this.setQuestionAnswer(
        selectedObj.keyDesc,
        selectedObj,
        questionObj,
        moduleObj
      );
    },
    getTextSelectedValue(answerObj, questionObj, moduleObject, answerIndex) {
      console.log(answerObj);
      console.log(questionObj);
      console.log(this.modulesArray);
      let multiTextBox = "";
      this.modulesArray.forEach(element => {
        if (element.moduleCode == moduleObject.moduleCode) {
          element.question.forEach((qes, index) => {
            if (qes.questionCode == questionObj.questionCode) {
              qes.answer.forEach(ans => {
                if (
                  ans.controlType == "M" &&
                  ans.answerCode == answerObj.answerCode
                ) {
                  multiTextBox = ans.keyDesc;
                }

                if (
                  ans.controlType == "T" &&
                  ans.answerCode == answerObj.answerCode &&
                  ans.keyCode == answerObj.keyCode
                ) {
                  console.log(answerIndex);
                  console.log(index);
                  multiTextBox = ans.keyDesc;
                }
              });
            }
          });
        }
      });
      return multiTextBox;
    },
    getRadioSelectedValue(answerObj, questionObj, moduleObject) {
      let radioButtonSelected = "";
      this.modulesArray.forEach(element => {
        if (element.moduleCode == moduleObject.moduleCode) {
          element.question.forEach(qes => {
            if (qes.questionCode == questionObj.questionCode) {
              qes.answer.forEach(ans => {
                if (
                  ans.controlType == "R" &&
                  ans.answerCode == answerObj.answerCode
                ) {
                  radioButtonSelected = ans.keyDesc;
                }
              });
            }
          });
        }
      });
      return radioButtonSelected;
    },
    getRadioSelectedkeyCode(answerObj, questionObj, moduleObject) {
      let radioButtonSelected = "";
      this.modulesArray.forEach(element => {
        if (element.moduleCode == moduleObject.moduleCode) {
          element.question.forEach(qes => {
            if (qes.questionCode == questionObj.questionCode) {
              qes.answer.forEach(ans => {
                if (
                  ans.controlType == "R" &&
                  ans.answerCode == answerObj.answerCode
                ) {
                  radioButtonSelected = ans.keyCode;
                }
              });
            }
          });
        }
      });
      return radioButtonSelected;
    },
    getDefaultTextValue(event) {
      console.log(event);
    },
    getSavedAnswer(answer) {
      // console.log(answer);
      var question = "-";
      if (answer && answer.length > 0) {
        answer.forEach(data => {
          var question = data.keyDesc;
          // return question;
        });
      }
      return question;
    },
    getWorkFlowHistoryDetails() {
      this.loading = true;
      partnerService.getWorkflowHistory(1, this.documentNumber).then(resp => {
        if (resp.response) {
          let data = {
            companyCode: resp.response[0].companyCode,
            orderType: resp.response[0].orderTypeCode
          };
          console.log(data);
          console.log("EVENT TRIGGRED");
          this.form.name = resp.response[0].name;
          this.form.email = resp.response[0].email;
          this.form.designation = resp.response[0].designation;
          this.form.mobileNumber = resp.response[0].mobileNumber;
          this.poNumber = resp.response[0].orderNumber;
          this.workflowjobType = resp.response[0].orderType;
          this.workflowOrderNumber = resp.response[0].orderNumber;
          this.vendorCode = resp.response[0].partnerNumber;
          this.jobCode = resp.response[0].jobCode;
          this.workflowJobCode = resp.response[0].jobCode;
          this.getEvaluationData = resp.response[0].modules;
          this.jobDesc = resp.response[0].jobDesc;
          this.poOrderDate = resp.response[0].orderDate;
          this.getEvaluationData.forEach((moduleData, index) => {
            moduleData.question.forEach((questionData, i) => {
              if (questionData.savedAnswer) {
                questionData.savedAnswer.forEach((answerData, ai) => {
                  this.setQuestionAnswer(
                    answerData.keyDesc,
                    answerData,
                    questionData,
                    moduleData
                  );
                });
              }
            });
          });
          this.loading = false;
          this.$emit("getuserValue", data);
        }
      });
    },
    getPartnerHistoryDetails() {
      this.loading = true;
      partnerService
        .getFeedbackHistory(
          this.companyCode,
          this.jobCode,
          this.poNumber,
          this.jobType,
          this.vendorCode,
          this.documentNumber
        )
        .then(resp => {
          if (resp.response) {
            this.form.name = resp.response[0].name;
            this.form.email = resp.response[0].email;
            this.form.designation = resp.response[0].designation;
            this.form.mobileNumber = resp.response[0].mobileNumber;

            // var moduleData = resp.response[0].modules;

            // moduleData.forEach((groupmodule, index) => {
            //   groupmodule.question.forEach((question, i) => {
            //     if (question.savedAnswer && question.savedAnswer.length > 0) {
            //       var groupdata = [];
            //       console.log(question);
            //       // groupdata.push(groupmodule);
            //       // groupdata.forEach(ques => {
            //       //   ques.question.push(question);
            //       // });
            //       console.log(groupdata);
            //     }
            //   });
            // });

            this.getEvaluationData = resp.response[0].modules;
            this.jobDesc = resp.response[0].jobDesc;
            this.poOrderDate = resp.response[0].orderDate;
            this.getEvaluationData.forEach((moduleData, index) => {
              moduleData.question.forEach((questionData, i) => {
                if (questionData.savedAnswer) {
                  questionData.savedAnswer.forEach((answerData, ai) => {
                    this.setQuestionAnswer(
                      answerData.keyDesc,
                      answerData,
                      questionData,
                      moduleData
                    );
                  });
                }
              });
            });
            this.loading = false;
          }
        });
    },
    getPartnerDraftDetails() {
      this.loading = true;
      partnerService
        .getDraftDetails(
          this.companyCode,
          this.jobCode,
          this.poNumber,
          this.jobType,
          this.vendorCode,
          this.documentNumber
        )
        .then(resp => {
          if (resp.response) {
            this.form.name = resp.response[0].name;
            this.form.email = resp.response[0].email;
            this.form.designation = resp.response[0].designation;
            this.form.mobileNumber = resp.response[0].mobileNumber;
            this.getEvaluationData = resp.response[0].modules;
            this.jobDesc = resp.response[0].jobDesc;
            this.poOrderDate = resp.response[0].orderDate;
            this.getEvaluationData.forEach((moduleData, index) => {
              moduleData.question.forEach((questionData, i) => {
                if (questionData.savedAnswer) {
                  questionData.savedAnswer.forEach((answerData, ai) => {
                    this.setQuestionAnswer(
                      answerData.keyDesc,
                      answerData,
                      questionData,
                      moduleData
                    );
                  });
                }
              });
            });
            this.loading = false;
          }
        });
    },
    changeModalSuccess() {      
      document.scrollingElement.scrollTop = 0;
      this.triggerModal = false;
      this.alertModal = false;
      if (this.successModal == true) {
        if (this.lastResponse == "Feedback saved in draft successfully") {
          this.successModal = false;
        } else {
          this.successModal = false;
         this.$emit("navigateBack", "New");
        }
      }
    },
    ratingUpdates(rating) {
      if (rating <= 50) {
        return "red";
      } else if (rating >= 75) {
        return "green";
      } else if (rating > 50 && rating < 75) {
        return "orange";
      }
    },
    navigateFeedbackPage() {
      console.log(this.FeedbackStatus);
      this.$emit("navigateBack", this.FeedbackStatus);
    },
    setQuestionAnswer(keyDesc, answerObj, questionObj, moduleObj) {
      console.log("answer", answerObj);
      let _moduleObject = {
        moduleCode: moduleObj.moduleCode,
        moduleDisplayOrder: moduleObj.moduleDisplayOrder,
        moduleLongDesc: moduleObj.moduleLongDesc,
        moduleShortDesc: moduleObj.moduleShortDesc,
        question: []
      };
      let _questionObject = {
        answer: [],
        parentQuestionCode: questionObj.parentQuestionCode,
        question: questionObj.question,
        questionCode: questionObj.questionCode,
        questionLevel: questionObj.questionLevel
      };

      if (
        answerObj.questionSpecificAnswersResponses &&
        answerObj.questionSpecificAnswersResponses.length > 0
      ) {
        var questionLevel = "S";
      } else {
        var questionLevel = "R";
      }

      let _answerObject = {
        answerCode: answerObj.answerCode,
        controlType: answerObj.controlType,
        displayOrder: answerObj.displayOrder,
        keyCode: answerObj.keyCode,
        keyDesc: keyDesc,
        keyValue: answerObj.keyValue,
        answerLevel: questionLevel,
        questionSpecificAnswersResponses: []
      };
      let _moduleIndex = this.modulesArray.findIndex(
        x => x.moduleCode == moduleObj.moduleCode
      );
      if (_moduleIndex != -1) {
        //find if module is already in module array
        this.modulesArray.forEach(moduleObject => {
          if (moduleObject.moduleCode == moduleObj.moduleCode) {
            _moduleObject = moduleObject;
          }
        });
      }
      //find if question is already in questions array of module
      if (_moduleObject.question.length > 0) {
        _moduleObject.question.forEach(question => {
          console.log(question.questionCode);
          console.log(questionObj.questionCode);
          if (question.questionCode == questionObj.questionCode) {
            _questionObject = question;
          }
        });
      }
      if (answerObj.controlType == "R") {
        //answer is already present so push new answer
        if (_questionObject.answer.length > 0) {
          // empty question.answerr array;
          // _questionObject.answer = [];
          let answerRadioIndex = _questionObject.answer.findIndex(
            x =>
              x.controlType === answerObj.controlType &&
              x.answerCode == _answerObject.answerCode
          );
          if (answerRadioIndex != -1) {
            _questionObject.answer.splice(answerRadioIndex, 1);
          }
        }
      } else if (answerObj.controlType == "M") {
        if (_questionObject.answer.length > 0) {
          let answerTextIndex = _questionObject.answer.findIndex(
            x =>
              x.controlType === answerObj.controlType &&
              x.keyCode == answerObj.keyCode
          );
          if (answerTextIndex != -1) {
            _questionObject.answer.splice(answerTextIndex, 1);
          }
        }
      } else if (answerObj.controlType == "T") {
        if (_questionObject.answer.length > 0) {
          let answerTextIndex = _questionObject.answer.findIndex(
            x =>
              x.controlType === answerObj.controlType &&
              x.keyCode == answerObj.keyCode
          );
          if (answerTextIndex != -1) {
            _questionObject.answer.splice(answerTextIndex, 1);
          }
          _questionObject.answer.forEach(ques => {
            if (ques.keyDesc == "") {
              _questionObject.answer.splice(answerTextIndex, 1);
            }
          });
        }
      }
      //add selectedAnswer to question
      _questionObject.answer.push(_answerObject);
      // console.log(_moduleObject);
      //text box question
      let questionIndex = _moduleObject.question.findIndex(
        item => item.questionCode === questionObj.questionCode
      );
      if (questionIndex != -1) {
        _moduleObject.question.splice(questionIndex, 1);
      }
      _moduleObject.question.push(_questionObject);
      // console.log(_moduleObject.question);
      //text box question module
      let moduleIndex = this.modulesArray.findIndex(
        item => item.moduleCode === moduleObj.moduleCode
      );
      if (moduleIndex != -1) {
        this.modulesArray.splice(moduleIndex, 1);
      }
      this.modulesArray.push(_moduleObject);
      console.log(this.modulesArray);
    },
    submitClaimRequest() {
      this.claimForm.reasonTypeCode = this.selectedReasonForVariation;
      this.claimForm.categoryCode = this.categoryCode;
      this.claimForm.attachmentTypeCode = this.selectedAttachmentType;
      this.claimForm.attachmentType = this.attachmentType;
      this.claimForm.variationDesc = this.reasonForVariation;
      this.claimForm.referenceDocument = this.referenceDocument;
      this.claimForm.employeeDetails = this.employeeDetails;
      this.claimForm.lntRepName = this.lntRepName;
      this.claimForm.lntRepMail = this.lntRepMail;
      this.claimForm.jobCode = this.jobCode;
      this.claimForm.orderNumber = this.orderNumber;
      if (this.documentNumber) {
        this.claimForm.documentNumber = this.documentNumber;
      }
      if (
        this.claimForm.reasonTypeCode == null ||
        this.claimForm.attachmentTypeCode == null ||
        this.claimForm.variationDesc == null ||
        this.claimForm.referenceDocument == null
      ) {
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse = "Please fill all details in Feedback Provider";
        return;
      }
      if (this.errors.items.length > 0) {
        this.errors.items.forEach(element => {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = element.msg;
        });
        return;
      }

      // if (this.modulesArray.length <= 0) {
      //   this.triggerModal = true;
      //   this.alertModal = true;
      //   this.lastResponse = "Atleast one feedback need to be answered";
      //   return;
      // }
      this.loading = true;
      this.form.dynamicQuestionControlResponse.modules = this.modulesArray;

      partnerService.saveDynamicDataAsDraft(this.form).then(resp => {
        if (resp.response) {
          this.triggerModal = true;
          this.successModal = true;
          this.loading = false;
          this.lastResponse = resp.response.Message;
          this.messageResponse = resp.response.DocumentNumber;
        } else {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = resp.failureMessage;
        }
      });
    },    
    submitFeedbackAsDraft() {
    this.saveDraftObj = {
      "attachmentDocIds": JSON.stringify(this.attachments),
      "attachmentType": "",
      "attachmentTypeCode": 56,
      "categoryCode": this.selectedCategory ,
      "companyCode": this.companyCode ,
      "documentNumber": "",
      "jobCode": this.jobCode,
      "lntRepEmail": "",
      "lntRepName": "",
      "orderNumber": this.poNumber,
      "reasonTypeCode": this.selectedReasonForVariation,
      "referenceDocument": this.form.referenceNumber,
      "employeeDetails":this.form.employeeDetails,
      "variationDesc": this.variationDesc,
      "attachmentSiteUrl": this.siteUrl
    }
      if (this.fetchedDocumentNumber) {
        this.documentNumber = this.claimObj.requestNumber;
      }
       if(this.viewAs == 'draft' || this.viewAs == 'history') {
         this.saveDraftObj.jobCode = this.claimObj.jobCode
         this.saveDraftObj.documentNumber = this.claimObj.requestNumber
       }
      if (!(JSON.parse(this.saveDraftObj.attachmentDocIds)[0].nameOfTheAttachment &&
      JSON.parse(this.saveDraftObj.attachmentDocIds)[0].attachmentFileId
        && this.saveDraftObj.jobCode
         && this.saveDraftObj.reasonTypeCode
          && this.saveDraftObj.referenceDocument
           && this.saveDraftObj.variationDesc)) {
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse = "Please fill all mandatory details in request form";
        return;
      }
      this.loading = true; 
      this.saveDraftObj.attachmentDocIds = JSON.stringify(
        JSON.parse(this.saveDraftObj.attachmentDocIds).filter(x=>x.nameOfTheAttachment && x.nameOfTheAttachment.trim() != '' && x.attachmentFileId && x.attachmentFileId.trim() !='')
      )
      partnerService.saveClaimDataAsDraft(this.saveDraftObj).then(resp => {
        if (resp.response) {
          this.triggerModal = true;
          this.successModal = true;
          this.loading = false;
          this.lastResponse = resp.response.Message;
          this.fetchedDocumentNumber = resp.response.DocumentNumber;
        } else {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = resp.failureMessage;
        }
      });
    },
    submitClaim() {      
      if (window.confirm("Do you want to submit this grievance request. Click OK to confirm?")) {
      //window.alert('submit claim called')
      if (this.fetchedDocumentNumber) {
        this.saveDraftObj.documentNumber = this.fetchedDocumentNumber;
      } else {        
        this.saveDraftObj = {
      "attachmentDocIds": JSON.stringify(this.attachments),
      "attachmentType": "",
      "attachmentTypeCode": 56,
      "categoryCode": this.selectedCategory,
      "companyCode": this.companyCode ,
      "documentNumber": "",
      "jobCode": this.jobCode,
      "lntRepEmail": "",
      "lntRepName": "",
      "orderNumber": this.poNumber,
      "reasonTypeCode": this.selectedReasonForVariation,
      "referenceDocument": this.form.referenceNumber,      
      "employeeDetails":this.form.employeeDetails,
      "variationDesc": this.variationDesc,
      "attachmentSiteUrl": this.siteUrl,
      }
      }
      
       if(this.viewAs == 'draft' || this.viewAs == 'history') {
         this.saveDraftObj.jobCode = this.claimObj.jobCode
         this.saveDraftObj.documentNumber = this.claimObj.requestNumber
         this.saveDraftObj.orderNumber = this.claimObj.orderNumber
       }
      if (!(JSON.parse(this.saveDraftObj.attachmentDocIds)[0].nameOfTheAttachment &&
      JSON.parse(this.saveDraftObj.attachmentDocIds)[0].attachmentFileId
        && this.saveDraftObj.jobCode
         && this.saveDraftObj.reasonTypeCode
          && this.saveDraftObj.referenceDocument
           && this.saveDraftObj.variationDesc) 
      ) {
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse = "Please fill all mandatory details in request form";
        return;
      }
      this.loading = true;

      this.saveDraftObj.attachmentDocIds = JSON.stringify(
        JSON.parse(this.saveDraftObj.attachmentDocIds).filter(x=>x.nameOfTheAttachment && x.nameOfTheAttachment.trim() != '' && x.attachmentFileId && x.attachmentFileId.trim() !='')
      )
      partnerService.saveClaimDataSubmit(this.saveDraftObj).then(resp => {
        if (resp.response) {
          this.triggerModal = true;
          this.successModal = true;
          this.loading = false;
          this.lastResponse = resp.response.Message + " Ref No: " + resp.response.DocumentNumber;
          this.fetchedDocumentNumber = resp.response.DocumentNumber;
        } else {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = resp.failureMessage;
        }
      });
      }
    },
  
    submitClaimReSubmit() {
      if (window.confirm("Do you want to re-submit this grievance request. Click OK to confirm?")) {
      if (this.fetchedDocumentNumber) {
        this.saveDraftObj.documentNumber = this.fetchedDocumentNumber;
      } else {        
        this.saveDraftObj = {
      "attachmentDocIds": JSON.stringify(this.attachments),
      "attachmentType": "",
      "attachmentTypeCode": 56,
      "categoryCode": this.claimObj.categoryCode,
      "companyCode": this.claimObj.companyCode,
      "documentNumber": "",
      "jobCode": this.claimObj.jobCode,
      "lntRepEmail": "",
      "lntRepName": "",
      "orderNumber": this.claimObj.orderNumber,
      "reasonTypeCode": this.selectedReasonForVariation,
      "referenceDocument": this.form.referenceNumber,      
      "employeeDetails":this.form.employeeDetails,
      "variationDesc": this.variationDesc,
      "attachmentSiteUrl": this.siteUrl
      }
      }
      
       if(this.viewAs == 'draft' || this.viewAs == 'history') {
         this.saveDraftObj.jobCode = this.claimObj.jobCode
         this.saveDraftObj.documentNumber = this.claimObj.requestNumber
       }
      if (!(JSON.parse(this.saveDraftObj.attachmentDocIds)[0].nameOfTheAttachment &&
      JSON.parse(this.saveDraftObj.attachmentDocIds)[0].attachmentFileId
        && this.saveDraftObj.jobCode
         && this.saveDraftObj.reasonTypeCode
          && this.saveDraftObj.referenceDocument
           && this.saveDraftObj.variationDesc) 
      ) {
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse = "Please fill all mandatory details in request form";
        return;
      }
      this.loading = true;

      this.saveDraftObj.attachmentDocIds = JSON.stringify(
        JSON.parse(this.saveDraftObj.attachmentDocIds).filter(x=>x.nameOfTheAttachment && x.nameOfTheAttachment.trim() != '' && x.attachmentFileId && x.attachmentFileId.trim() !='')
      )
      partnerService.saveClaimDataSubmit(this.saveDraftObj).then(resp => {
        if (resp.response) {
          this.triggerModal = true;
          this.successModal = true;
          this.loading = false;
          this.lastResponse = resp.response.Message + " Ref No: " + resp.response.DocumentNumber;
          this.fetchedDocumentNumber = resp.response.DocumentNumber;
        } else {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = resp.failureMessage;
        }
      });
    }
  }
  }
}
</script>

<style scoped>
.textarea.form-control {
  height: 350px;
  width: 75%;
}
.testimonials-paragraph > textarea {
  height: 200px !important;
  margin-left: 20%;
}
.testimonials-paragraph {
  margin-left: 5%;
  margin-right: 100px;
}
.question-text {
  font-size: 16px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}
.question-answer {
  font-size: 16px;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}
.question-answer-add {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}

.question-additional-answer {
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #1579ab;
  text-decoration: underline;
}
.text-heading {
  font-size: 18px;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  color: #000000;
}
.text-subheading {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  color: #000000;
}
.text-subheading-value {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  color: #000000;
}
.question-additional-text {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}
.card-additional-background {
  /* width: 774px;
  height: 90px; */
  border-radius: 2px;
  border: solid 1px #c3c3c3;
  background-color: #f8f8f8 !important;
}
.subTitleClass {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
}
.text-input-feild {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-weight: 500; /* font-style: italic; */
  text-align: left;
}
.f-bold{  
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  text-align: left;
  font-weight: bold !important;
}
.cancel-button {
  border: solid 1px #707070;
  background-color: #ffffff;
  font-family: "Open Sans", sans-serif !important;
  color: #484848;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.draft-button {
  border: solid 1px #0e5d84;
  background-color: #ffffff;
  font-family: "Open Sans", sans-serif !important;
  color: #0e5d84;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.submit-button {
  background-color: #0c5e9d;
  font-family: "Open Sans", sans-serif !important;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.dottedBlack {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #000;
  float: left;
  margin-top: 6px;
}
.back-arrow-icon {
  /* border: solid 1px #707070; */
  color: black !important;
  font-family: "Open Sans", sans-serif !important;
  margin: 0.5px 0px 0px 3px !important;
  height: 25px !important;
  transform: rotate(180deg);
  width: 20px;
}

.back-arrow-image {
  border-radius: 60%;
  background-color: rgb(255, 255, 255) !important;
  z-index: 5;
  position: fixed;
  top: 78px;
  right: 10px;
  cursor: pointer;
  /* float: right; */
}
.multi-select {
  width: 80%;
}
.disabled{
  pointer-events: none;
  cursor: default;
  cursor: not-allowed !important;
  opacity: 0.8;
  color:#000;
  
}
.disabled-opaque{
  pointer-events: none;
  cursor: default;
  cursor: not-allowed !important;
  opacity: 0.5;
  color:#000 !important;
  border: 1px solid #000 !important;
}
.editreasonlink:hover{
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

.editreasonlink{
  cursor: pointer;
}

.claim-details-table{width: 100%;    font-size: 16px;
    color: #000;}
.claim-details-table td:first-child{min-width: 180px;}
.claim-details-table tr,.claim-details-table td{
 text-align: left;background: #fefefe;
}
#trace td,th{
text-align: left;
}
#trace{
  padding: 20px;
text-align: left;
}
</style>
<style>
/* .v-expansion-panel__header {
  background-color: #6192b1 !important;
  line-height: 0 !important;
  margin-bottom: 2% !important;
  color: #ffffff !important;
  font-size: 18px;
  font-family: "Open Sans", sans-serif !important;
  font-weight: 500 !important;
} */
</style>

